import React from "react";

export default function MSAccess_Second() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Second</h1>
      <p>This is the MSAccess_Second component generated from the SQL JSON.</p>
    </div>
  );
}
